<div class="header-section-item flex-row top-space-section" *ngIf="isLoginAsClientManager">
    <div class="client-manager-div">This is how Client Managers view Research Credit Navigator
    </div>
    <div class="client-manager-close btn btn-secondary" (click)="exitClientView()" >
        Exit Client Manager View &nbsp;<i class="fas fa-times close-button"></i>
    </div>
</div>
